import React, { useEffect } from 'react';
import styles from '../Wyszukiwarka.module.css';
import { useZamowienia } from 'hooks/useZamowienia';

  export default function DataPrzyjecia({dataPrzyjecia, setDataPrzyjecia} ){

          const { globalSearch } = useZamowienia();
  
          useEffect(() => {
        globalSearch();
      
    }, [dataPrzyjecia]);  
  return(
      <div className={styles.colData_nr}>
      <label className={styles.labelData}> Przyjęcie </label>
      <input className={styles.inputData} style={{width:"130px"}} type="month"
            value={dataPrzyjecia}
            onChange={(event) => {
  
              setDataPrzyjecia(event.target.value);
              
            }}></input>
    </div>
  );
}